module.exports = __webpack_public_path__ + "static/media/OPTIV_rgb.d9b28133.jpg";